import { MdNotificationsActive, MdNotificationsNone } from 'react-icons/md';

function StockAlertButton(props: {
    productId: string;
    isSubscribed: boolean;
    onToggle: (productId: string, isSubscribed: boolean) => void;
}) {
    const { productId, isSubscribed, onToggle } = props;

    return (
        <button
            onClick={(e) => {
                e.stopPropagation();
                onToggle(productId, isSubscribed);
            }}
            className={`flex items-center justify-center gap-1.5 w-full px-2 py-1.5 rounded-lg text-xs font-semibold transition-colors ${
                isSubscribed
                    ? 'bg-blue-100 text-blue-700 hover:bg-blue-200'
                    : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
            }`}
        >
            {isSubscribed ? (
                <>
                    <MdNotificationsActive size={14} />
                    Alerte activée
                </>
            ) : (
                <>
                    <MdNotificationsNone size={14} />
                    M'alerter quand disponible
                </>
            )}
        </button>
    );
}

export default StockAlertButton;
